import React, { useState } from "react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "./../LibSplide/LibSplide.scss";
import "./HomeSlider.scss";
import { useEffect } from "react";
import api from "api";

export default function HomeSlider(props){
    
    const[Slides, setSlides] = useState(false);

    useEffect(() =>{
        api('/Slider', 'get', {})
            .then(response => {
                setSlides(response.slider);
            })
    }, []);

    return(
        <div className="container">
            {
                Slides !== false && Slides.length > 0 &&
                <div className="splide-arrow-black">
                    <div id="home-slider">
                        <Splide 
                            options={{
                                Perpage : 1
                                ,arrowPath : ' '
                                ,pagination : false
                            }} 
                            onActive={(component, slide) => {
                                props.onChanged.apply(null, [Slides[slide.index]])
                            }}
                        >
                            {  Slides.map((slide) => (
                                <SplideSlide key={slide.id}>
                                    <div className="wrapper relative">
                                        <span className="block bold mb-md">{slide.title}</span>
                                        <div className="slide-content">
                                            <div className="slide-title leading-text text-sm">{slide.desc}</div>
                                        </div>
                                        <div className="mt-md">
                                            <a href={slide.url} className="absolute color-brand bold text-sm">Read More</a>
                                        </div>
                                    </div>
                                </SplideSlide>
                            ))}
                        </Splide>
                    </div>
                </div>
            }
        </div>
    )
}
